import Vue from 'vue'
import Vuetify, {VSnackbar, VBtn, VIcon} from 'vuetify/lib'

Vue.use(Vuetify)

Vue.component("v-snackbar", VSnackbar);
Vue.component("v-btn", VBtn);
Vue.component("v-icon", VIcon);
export default new Vuetify({
    breakpoint: {
        mobileBreakpoint: 'sm' // 这个值等于960
    },
    theme: {
        dark: true,
        themes: {
            light: {
                primary: '#CBAA5C',
                secondary: '#083759',
            },
            dark:{
                primary:'#FFF',
                // primary: '#CBAA5C',
                secondary: '#083759',
            }
        },
    },
})
